import Vue from 'vue'
import Vuex from 'vuex'
import layout from '@/ox/src/store/layout'
import snackbar from '@/ox/src/store/snackbar'
import auth from './auth'
import course from './course'
import chapter from './chapter'
import question from './question'
import member from './member'
import statistic from './statistic'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    layout,
    snackbar,
    auth,
    course,
    member,
    chapter,
    question,
    statistic
  }
})
